/** Sala LiveKit aberta para testes de layout/cenário/conexão (sem convites). */
export const LIVEKIT_OPEN_TEST_ROOM_ID = "sala-livekit-teste";

export function isLiveKitOpenTestRoom(roomId: string | null | undefined): boolean {
  if (!roomId) {
    return false;
  }
  return roomId === LIVEKIT_OPEN_TEST_ROOM_ID;
}

export function liveKitOpenTestRoomUrl(baseUrl = "https://app.constelabrasil.com.br"): string {
  return `${baseUrl}/sala-beta/${LIVEKIT_OPEN_TEST_ROOM_ID}`;
}
